import React, { useState } from 'react';
import { BarChart2Icon, PieChartIcon, TrendingUpIcon, UsersIcon } from 'lucide-react';
import Button from './Button';
import Wizard from './Wizard';
const AnalyticsSnapshot = () => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  return <section id="analytics" className="py-16 bg-white" data-id="element-855">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-856">
        <div className="text-center mb-12" data-id="element-857">
          <h2 className="text-3xl font-bold mb-4" data-id="element-858">
            Powerful Analytics & Insights
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-859">
            Track performance and understand customer behavior with detailed
            analytics
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-860">
          <div className="bg-white rounded-xl p-6 shadow-card border border-gray-100" data-id="element-861">
            <div className="flex items-center gap-3 mb-6" data-id="element-862">
              <BarChart2Icon className="h-6 w-6 text-primary" data-id="element-863" />
              <h3 className="text-xl font-bold" data-id="element-864">Conversation Analytics</h3>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 mb-4" data-id="element-865">
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-866">
                <div data-id="element-867">
                  <div className="text-sm text-gray-500" data-id="element-868">
                    Total Conversations
                  </div>
                  <div className="text-2xl font-bold" data-id="element-869">24,815</div>
                </div>
                <div data-id="element-870">
                  <div className="text-sm text-gray-500" data-id="element-871">Avg. Duration</div>
                  <div className="text-2xl font-bold" data-id="element-872">3.2 min</div>
                </div>
              </div>
              <div data-id="element-873">
                <div className="text-sm text-gray-500 mb-2" data-id="element-874">Top Intents</div>
                <div className="space-y-2" data-id="element-875">
                  <div data-id="element-876">
                    <div className="flex justify-between text-sm mb-1" data-id="element-877">
                      <span data-id="element-878">Product comparison</span>
                      <span data-id="element-879">32%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-880">
                      <div className="bg-primary h-2 rounded-full" style={{
                      width: '32%'
                    }} data-id="element-881"></div>
                    </div>
                  </div>
                  <div data-id="element-882">
                    <div className="flex justify-between text-sm mb-1" data-id="element-883">
                      <span data-id="element-884">Price inquiry</span>
                      <span data-id="element-885">28%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-886">
                      <div className="bg-primary h-2 rounded-full" style={{
                      width: '28%'
                    }} data-id="element-887"></div>
                    </div>
                  </div>
                  <div data-id="element-888">
                    <div className="flex justify-between text-sm mb-1" data-id="element-889">
                      <span data-id="element-890">Feature questions</span>
                      <span data-id="element-891">24%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-892">
                      <div className="bg-primary h-2 rounded-full" style={{
                      width: '24%'
                    }} data-id="element-893"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Button variant="outline" fullWidth onClick={() => setIsWizardOpen(true)} data-id="element-894">
              Explore Conversation Analytics
            </Button>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-card border border-gray-100" data-id="element-895">
            <div className="flex items-center gap-3 mb-6" data-id="element-896">
              <TrendingUpIcon className="h-6 w-6 text-primary" data-id="element-897" />
              <h3 className="text-xl font-bold" data-id="element-898">Conversion Metrics</h3>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 mb-4" data-id="element-899">
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-900">
                <div data-id="element-901">
                  <div className="text-sm text-gray-500" data-id="element-902">Conversion Rate</div>
                  <div className="text-2xl font-bold" data-id="element-903">8.7%</div>
                  <div className="text-xs text-green-500 flex items-center" data-id="element-904">
                    <TrendingUpIcon className="h-3 w-3 mr-1" data-id="element-905" /> +2.3% vs. site
                    avg
                  </div>
                </div>
                <div data-id="element-906">
                  <div className="text-sm text-gray-500" data-id="element-907">Avg. Order Value</div>
                  <div className="text-2xl font-bold" data-id="element-908">$124</div>
                  <div className="text-xs text-green-500 flex items-center" data-id="element-909">
                    <TrendingUpIcon className="h-3 w-3 mr-1" data-id="element-910" /> +18% vs. site
                    avg
                  </div>
                </div>
              </div>
              <div data-id="element-911">
                <div className="text-sm text-gray-500 mb-2" data-id="element-912">
                  Funnel Visualization
                </div>
                <div className="flex items-end h-24 gap-1" data-id="element-913">
                  <div className="flex-1 bg-primary h-full rounded-t text-xs text-white flex items-end justify-center pb-1" data-id="element-914">
                    100%
                  </div>
                  <div className="flex-1 bg-primary h-[70%] rounded-t text-xs text-white flex items-end justify-center pb-1" data-id="element-915">
                    70%
                  </div>
                  <div className="flex-1 bg-primary h-[40%] rounded-t text-xs text-white flex items-end justify-center pb-1" data-id="element-916">
                    40%
                  </div>
                  <div className="flex-1 bg-primary h-[8.7%] rounded-t text-xs text-white flex items-end justify-center pb-1" data-id="element-917">
                    8.7%
                  </div>
                </div>
                <div className="flex text-xs text-gray-500 mt-1" data-id="element-918">
                  <div className="flex-1 text-center" data-id="element-919">Chat</div>
                  <div className="flex-1 text-center" data-id="element-920">View</div>
                  <div className="flex-1 text-center" data-id="element-921">Cart</div>
                  <div className="flex-1 text-center" data-id="element-922">Purchase</div>
                </div>
              </div>
            </div>
            <Button variant="outline" fullWidth onClick={() => setIsWizardOpen(true)} data-id="element-923">
              Explore Conversion Analytics
            </Button>
          </div>
        </div>
        <div className="bg-primary/5 rounded-xl p-8 border border-primary/20" data-id="element-924">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-925">
            <div data-id="element-926">
              <h3 className="text-2xl font-bold mb-4" data-id="element-927">Actionable Insights</h3>
              <p className="text-gray-600 mb-6" data-id="element-928">
                Our analytics dashboard doesn't just show data—it provides
                actionable insights to help you optimize your product catalog,
                marketing strategies, and customer experience.
              </p>
              <ul className="space-y-3 mb-6" data-id="element-929">
                <li className="flex items-start" data-id="element-930">
                  <PieChartIcon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" data-id="element-931" />
                  <span className="ml-3 text-gray-600" data-id="element-932">
                    Identify high-performing products and categories
                  </span>
                </li>
                <li className="flex items-start" data-id="element-933">
                  <UsersIcon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" data-id="element-934" />
                  <span className="ml-3 text-gray-600" data-id="element-935">
                    Understand customer segments and preferences
                  </span>
                </li>
                <li className="flex items-start" data-id="element-936">
                  <BarChart2Icon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" data-id="element-937" />
                  <span className="ml-3 text-gray-600" data-id="element-938">
                    Optimize pricing and promotion strategies
                  </span>
                </li>
              </ul>
              <Button variant="primary" onClick={() => setIsWizardOpen(true)} data-id="element-939">
                Get Access to Analytics Dashboard
              </Button>
            </div>
            <div className="bg-white rounded-xl p-4 shadow-sm" data-id="element-940">
              <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Analytics Dashboard" className="rounded-lg w-full h-auto" data-id="element-941" />
            </div>
          </div>
        </div>
      </div>
      <Wizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-942" />
    </section>;
};
export default AnalyticsSnapshot;